import React from 'react'
import styles from './styles.scss'


/* const LoaderComponent = props => {
  const size = props.size || ''
  const style = {
    color: props.color || null
  }
  return (
    <div className={`la-ball-fall ${size}`} style={style}>
      <div />
      <div />
      <div />
    </div>
  )
}

const SpinnerLoader = () => (
  <div>
    <div className="loader loader-spinner" />
  </div>
) */

const MagazineLoader = () => (
  <div className={styles['wrapper-loading__magazine']}>
    <div className={styles['wrapper-loading__magazine-book']}>
      <div className={styles['wrapper-loading__magazine-book-page']} />
      <div className={styles['wrapper-loading__magazine-book-page']} />
      <div className={styles['wrapper-loading__magazine-book-page']} />
    </div>
  </div>
)

const Loading = props => {
  return <MagazineLoader />
}

export default Loading



// WEBPACK FOOTER //
// ./src/components/Loading/index.js